<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { boolCompare } from "@common/Common";
    import { MeetingQuestionReviewReadModel, ScoringVoteEntry } from "@Evaluation/AlternativesSurveys/Domain/readmodels";
    import MeetingQuestionReviewDr from "@Evaluation/AlternativesSurveys/Components/MeetingQuestionReviewDr.vue";
    import MeetingQuestionReviewPc from "@Evaluation/AlternativesSurveys/Components/MeetingQuestionReviewPc.vue";
    import AlternativeDetailsDialog from "@Alternatives/Alternatives/Components/AlternativeDetailsDialog.vue";
    import { AlternativeDetailsDialogViewModel } from "@Alternatives/Alternatives/Components/AlternativeDetailsDialog";
    import CriterionDetailsDialog from "@Criteria/Hierarchies/Components/CriterionDetailsDialog.vue";
    import { CriterionDetailsDialogViewModel } from "@Criteria/Hierarchies/Components/CriterionDetailsDialog";

    @Component({
        components: { MeetingQuestionReviewDr, MeetingQuestionReviewPc, AlternativeDetailsDialog, CriterionDetailsDialog },
        props: {
            propRm: { type: Object, required: false, default: null },
            propIsMeetingManager: { type: Boolean, required: true },
        }
    })
    export default class MeetingQuestionReview extends Vue
    {
        get rm(): MeetingQuestionReviewReadModel { return this.$props.propRm as MeetingQuestionReviewReadModel; }
        get isMeetingManager(): boolean { return this.$props.propIsMeetingManager; }

        alternativeDetailsDialog: AlternativeDetailsDialogViewModel = new AlternativeDetailsDialogViewModel();
        criterionDetailsDialog: CriterionDetailsDialogViewModel = new CriterionDetailsDialogViewModel();

        get contextName(): string { return this.rm?.CriterionName; }
        get votesEntries(): ScoringVoteEntry[] { return (this.rm?.VotesEntries ?? []).sort((a, b) => boolCompare(a.SurveyId != null, b.SurveyId != null)); }
        get value(): number | null { return this.rm?.Value; }
        get comment(): string { return this.rm?.Comment; }
        get scaleLevels() { return this.rm?.ScaleLevels ?? []; }
        get alternativeName(): string { return this.rm?.AlternativeName; }
        get firstAlternativeName(): string { return this.rm?.FirstAlternativeName; }
        get secondAlternativeName(): string { return this.rm?.SecondAlternativeName; }

        showAlternativeDetails()
        {
            this.alternativeDetailsDialog.show(this.rm.AlternativeName, this.rm.AlternativeDescription);
        }

        showFirstAlternativeDetails()
        {
            this.alternativeDetailsDialog.show(this.rm.FirstAlternativeName, this.rm.FirstAlternativeDescription);
        }

        showSecondAlternativeDetails()
        {
            this.alternativeDetailsDialog.show(this.rm.SecondAlternativeName, this.rm.SecondAlternativeDescription);
        }

        showCriterionDetails()
        {
            this.criterionDetailsDialog.show(this.rm.CriterionName, this.rm.CriterionPath, this.rm.CriterionDescription);
        }

        updateVoteValue(val: number | null)
        {
            this.$emit('update-vote-value', val);
        }

        updateVoteComment(comment: string | null)
        {
            this.$emit('update-vote-comment', comment);
        }
    }
</script>

<template>
    <div v-if="rm">
        <CriterionDetailsDialog :viewModel="criterionDetailsDialog" />

        <AlternativeDetailsDialog :viewModel="alternativeDetailsDialog" />

        <MeetingQuestionReviewDr v-if="rm.AlternativeId"
                                 :propIsMeetingManager="isMeetingManager"
                                 :propContextName="contextName"
                                 :propValue="value"
                                 :propComment="comment"
                                 :propVotesEntries="votesEntries"
                                 :propAlternativeName="alternativeName"
                                 :propScaleLevels="scaleLevels"
                                 @show-alternative-details="showAlternativeDetails"
                                 @show-criterion-details="showCriterionDetails"
                                 @update-vote-value="updateVoteValue"
                                 @update-vote-comment="updateVoteComment" />

        <MeetingQuestionReviewPc v-if="!rm.AlternativeId"
                                 :propIsMeetingManager="isMeetingManager"
                                 :propContextName="contextName"
                                 :propValue="value"
                                 :propComment="comment"
                                 :propVotesEntries="votesEntries"
                                 :propFirstAlternativeName="firstAlternativeName"
                                 :propSecondAlternativeName="secondAlternativeName"
                                 @show-first-alternative-details="showFirstAlternativeDetails"
                                 @show-second-alternative-details="showSecondAlternativeDetails"
                                 @show-criterion-details="showCriterionDetails"
                                 @update-vote-value="updateVoteValue"
                                 @update-vote-comment="updateVoteComment" />
    </div>
</template>
